import { PATHS as SHARED_PATHS } from '@shared/router/paths';

/**
 * HRMS routes. Shared auth / landing paths come from the foundation; every
 * screen here belongs to the HRMS application (people-service, hrms-backend,
 * and the read-only company-master lookups on finance-service).
 */
export const PATHS = {
  ...SHARED_PATHS,
  app: {
    ...SHARED_PATHS.app,
    dashboard: '/dashboard',

    // People (people-service + HR records on hrms-backend)
    employees: '/employees',
    /** The Employees page with the incomplete-profile filter applied (URL state). */
    employeesIncompleteProfiles: '/employees?profile_completion=incomplete',
    employeeNew: '/employees/new',
    /** The signed-in user's own employee record (static, out-ranks `:employeeId`). */
    myProfile: '/employees/me',
    employeeProfile: (employeeId = ':employeeId') => `/employees/${employeeId}`,
    employeeEdit: (employeeId = ':employeeId') => `/employees/${employeeId}/edit`,
    employeePermissions: (employeeId = ':employeeId') => `/employees/${employeeId}/permissions`,
    employeeRecord: (employeeId = ':employeeId', area = ':area') =>
      `/employees/${employeeId}/${area}`,
    organization: '/organization',

    // Login accounts (identity-service)
    users: '/users',
    userNew: '/users/new',
    userDetail: (userId = ':userId') => `/users/${userId}`,
    userAddEmployee: (userId = ':userId') => `/users/${userId}?addEmployee=1`,

    // Attendance & leave (hrms-backend)
    attendance: '/attendance',
    leaveRequests: '/leave/requests',
    leaveBalances: '/leave/balances',
    leavePolicies: '/leave/policies',
    leaveTypes: '/leave/types',
    holidays: '/holidays',
    separations: '/separations',
    separationDetail: (exitId = ':exitId') => `/separations/${exitId}`,

    // Payroll (hrms-backend)
    payroll: '/payroll',
    payrollRuns: '/payroll/runs',
    payrollCompensation: '/payroll/compensation',
    payrollPayments: '/payroll/payments',
    payrollAdjustments: '/payroll/adjustments',

    // Projects (hrms-backend)
    projects: '/projects',
    projectStatuses: '/projects/statuses',
    projectRoles: '/projects/roles',
    moduleStatuses: '/projects/module-statuses',

    // Integrations & reports (hrms-backend)
    teamLogger: '/integrations/teamlogger',
    teamLoggerManualReview: '/integrations/teamlogger/manual-review',
    projectMappings: '/integrations/project-mappings',
    asana: '/integrations/asana',
    userLogs: '/reports/user-logs',
    projectLogs: '/reports/project-logs',
    exports: '/reports/exports',

    // Access (identity-service, read-only here: Finance administers access)
    roles: '/access/roles',
    permissions: '/access/permissions',

    // Audit (audit-service; no application required)
    auditLogs: '/audit/logs',
  },
} as const;
